const messages = {
  title: "Marketing Toestemmingen",
  required: "Verplicht",
  answered: "✓ Beantwoord",
  read: "Gelezen",
  notRead: "Niet gelezen",
  alreadyAnswered: "Al beantwoord",
  requiredQuestionsMustBeAccepted: "{count} verplichte vraag{plural} moet{plural} worden geaccepteerd",
  pleaseAnswerQuestions: "Beantwoord de volgende vragen:",
  iAccept: "Ik accepteer",
  scrollToUnlock: "Scroll naar beneden om te ontgrendelen",
  fieldRequired: "Dit veld is verplicht",
  scrollToContinue: "↓ Scroll naar beneden om door te gaan",
  saving: "Opslaan...",
  saveConsents: "Toestemmingen opslaan",
  allRequiredAccepted: "✓ Alle verplichte vragen geaccepteerd",
  requiredConsentsCompleted: "{completed}/{total} verplichte toestemmingen voltooid",
  selectConsentToView: "Selecteer een toestemming uit de lijst om de inhoud te bekijken",
  readAllContentFirst: "Lees eerst alle inhoud: {names}",
  acceptAllRequiredIn: "Accepteer alle verplichte vragen in: {names}",
  acceptAllBeforeSaving: "Accepteer alle verplichte vragen voordat u opslaat.",
  failedToSave: "Opslaan van toestemmingen mislukt. Probeer het opnieuw.",
  errorSaving: "Er is een fout opgetreden bij het opslaan van toestemmingen. Probeer het opnieuw.",
  failedToLoad: "Laden van toestemmingen mislukt. Ververs de pagina.",
  viewPdf: "PDF bekijken",
  requiredConsentTitle: "Verplichte toestemming",
  acceptAndContinue: "Accepteer en ga verder",
};

export default {
  messages,
};
